import clsx from 'clsx';
import React, { useMemo } from 'react';
import { getKeyIconClass } from '../../../a11y/shortcuts/utils/shortcutIcon';
import { getKeyFromCommand } from '../../../a11y/shortcuts/utils/keyboardShortcuts';
import styles from './SecondarySidebarItemTooltip.module.scss';

export function SecondarySidebarItemTooltip({
  command,
  showLabel,
  label
}: {
  command: string;
  showLabel: boolean;
  label: string;
}) {
  const keyCombination = useMemo(() => getKeyFromCommand(command), [ command ]);

  return (
    <div className='center-flex-row'>
      {showLabel ? (
        <span className={`text-bold ${styles.textBold}`}>
          {label}
        </span>
      ) : null}

      {keyCombination ? (
        <div className={styles.shortcut}>
          {keyCombination.split('.').map((key, index) => (
            <React.Fragment key={index}>
              {getKeyIconClass(key) ? (
                <span className={clsx('hevo-icon', styles.icon, getKeyIconClass(key))} />
              ) : key}
            </React.Fragment>
          ))}
        </div>
      ) : null}
    </div>
  );
}
